import React from 'react'
import ReactPaginate from 'react-paginate'
import FetchData from '../../shared/fetchData'
import Search from'../../components/UI/Search/Search'
import Button from '../../components/UI/Button/Button'
import Input from '../../components/UI/Input/Input'
import {updateObject} from '../../shared/utility'
import Fade from 'react-reveal/Fade'
import Add from '@material-ui/icons/Add'
import ShiftForm from '../../components/Shift/ShiftForm/ShiftForm'
import Shift from '../../components/Shift/Shift'

        const Shifts = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [offset, setOffset] = React.useState(1)
    const [perPage, setPerPage] = React.useState(3)
    const [pageCount, setPageCount] = React.useState(0)
    const [permission, setPermission] = React.useState(window.localStorage.getItem("permission"))
    const [shifts, setShifts] = React.useState([])
    const [newShiftPage, setNewShiftPage] = React.useState(false)
    const [edit, setEdit] = React.useState(false)
    const [shift, setShift] = React.useState('')
    const [searchParams, setSearchParams] = React.useState({
        description: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'نام'
            },
            validation: {
                required: true
            },
            errorMessage: '',
            valid: true,
            value: ''
        }
    })

    React.useEffect(() => {
        setLoading(true)
        var raw = JSON.stringify({
            "shift": {
            },
            "pl": perPage,
            "pn": offset,
            "version": "mtpx001"
        })

        var url = 'management/api/v1/shifts/getShifts'
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setLoading(false)
                    if (result.status == 0) {
                        setPageCount(result.count / parseInt(perPage))
                        setShifts(result.shifts)
                    }
                })
                .catch(error => setLoading(false))
    }, [])

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(searchParams, {
            [controlName]: updateObject(searchParams[controlName], {
                value: event.target.value
            })
        });
        setSearchParams(updatedControls)
    }

    const search = (event) => {
        var raw = JSON.stringify({
            "shift": {
                "description": searchParams.description.value
            },
            "pl": perPage,
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/shifts/getShifts'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setLoading(false)
                    if (result.status == 0) {
                        setPageCount(result.count / parseInt(perPage))
                        setShifts(result.shifts)
                    }
                })
                .catch(error => setLoading(false))
    }

    const handlePageClick = (e) => {
        setOffset(e.selected + 1)
        var raw = JSON.stringify({
            "shift": {
                "description": searchParams.description.value
            },
            "pl": perPage,
            "pn": e.selected + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/shifts/getShifts'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setLoading(false)
                    if (result.status == 0) {
                        setPageCount(result.count / parseInt(perPage))
                        setShifts(result.shifts)
                    }
                })
                .catch(error => setLoading(false))
    }

    const refresh = (event) => {
        setLoading(true)
        var raw = JSON.stringify({
            "shift": {
            },
            "pl": perPage,
            "pn": 1,
            "version": "mtpx001"
        })

        var url = 'management/api/v1/shifts/getShifts'
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setLoading(false)
                    if (result.status == 0) {
                        setPageCount(result.count / parseInt(perPage))
                        setShifts(result.shifts)
                    }
                })
                .catch(error => setLoading(false))
    }

    const toggleNewLockerForm = (event, value) => {
        if (value == false) {
            var raw = JSON.stringify({
                "shift": {
                    "description": searchParams.description.value
                },
                "pl": perPage,
                "pn": offset,
                "version": "mtpx001"
            })
            var url = 'management/api/v1/shifts/getShifts'
            setLoading(true)
            FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        setLoading(false)
                        if (result.status == 0) {
                            setPageCount(result.count / parseInt(perPage))
                            setShifts(result.shifts)
                        }
                    })
                    .catch(error => setLoading(false))
        }
        setNewShiftPage(value)
    }

    const addNewShift = (event, id) => {
        setShift('')
        setEdit(false)
        toggleNewLockerForm(event, true)
    }

    const editShift = (event, id) => {
        const lckrTp = shifts.filter(l => l.id == id)
        if (lckrTp != null && lckrTp.length != 0) {
            setShift(lckrTp[0])
            setEdit(true)
            toggleNewLockerForm(event, true)
        }
    }


    const formElementsArray = [];
    for (let key in searchParams) {
        formElementsArray.push({
            id: key,
            config: searchParams[key]
        })
    }

    let form = formElementsArray.map(formElement => {
        return (
                <Input
                    key={formElement.id}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    placeholder={formElement.config.placeholder}
                    errorMessage={formElement.config.errorMessage}
                    search={true}
                    col="3 mt-2"
                    changed={(event) => inputChangedHandler(event, formElement.id)} />
                );
    })
    form = <div>
        <div className="row pl-4" dir="ltr" style={{height: '0px'}}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            {form}
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-2">
                <Button btnType="search-btn" clicked={search}>جستجو</Button>
            </div>
        </div>
    </div>

    const shiftList = shifts != null && shifts.length != 0 ? shifts.map(l => {
        return(<Shift edit={editShift} shift={l} />)
    }) : ''
    return (
            <div>
                {!newShiftPage ?
                            <Fade duration={200} left cascade>
                                <div>
                                    <Search class="orders-search" form={form} />
                                    {permission.includes != null && permission.includes('LOCKER_TYPE_WRITE') ?
                                                <div className="row justify-content-center mt-3 ml-3">
                                                    <div className="UserGeneralBtn">
                                                        <div onClick={(event) => addNewShift(event)} className="Add">
                                                            <Add className="UserIcon" />
                                                        </div>
                                                    </div>
                                                </div>
                                                    : ''
                                    }
                                    <div className="row justify-content-center mt-1">
                                        {shiftList}
                                    </div>
                                    {shifts != null && shifts.length != 0 ?
                                                <div className="row justify-content-center">
                                                    <ReactPaginate
                                                        previousLabel={"→قبلی"}
                                                        nextLabel={"بعدی←"}
                                                        forcePage={offset >= 0 ? offset - 1 : offset}
                                                        breakLabel={"..."}
                                                        breakClassName={"break-me"}
                                                        pageCount={pageCount}
                                                        marginPagesDisplayed={2}
                                                        pageRangeDisplayed={5}
                                                        onPageChange={handlePageClick}
                                                        containerClassName="pagination"
                                                        subContainerClassName={"pages pagination"}
                                                        activeClassName={"active"} />
                                                </div>
                                                    : ''}
                                </div>
                            </Fade>
                            :
                            <ShiftForm edit={edit} shift={edit ? shift : ''} toggleNewLockerForm={toggleNewLockerForm} />
                }
            </div>
            )
}

export default Shifts